/**
 *
 * AdministratorBCMobileGrid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedMobileGrid from 'containers/AdvancedMobileGrid';
import { TENANT_ANNOUNCEMENT_DX_GRID } from './constants';
import { RowComponent, getRowHeight } from '../common/mobile';

class TenantMobileGrid extends React.PureComponent {
  getFilters() {
    return [];
  }

  getDetailRowFields() {
    return [
      {
        name: 'name',
        title: 'Наименование',
      },
      {
        name: 'content',
        title: 'Содержание',
      },
    ];
  }

  getActionButtons() {
    return [];
  }

  getActionMenuItems() {
    return [];
  }

  getSorting() {
    return [{ columnId: 'name', columnName: 'name', direction: 'desc' }];
  }

  render() {
    const { onActionExecuting, viewName } = this.props;

    return (
      <AdvancedMobileGrid
        entityName="announcements"
        name={TENANT_ANNOUNCEMENT_DX_GRID}
        actionButtons={this.getActionButtons()}
        actionMenuItems={this.getActionMenuItems()}
        detailRowFields={this.getDetailRowFields()}
        filters={this.getFilters()}
        getRowHeight={getRowHeight}
        onActionExecuting={onActionExecuting}
        rowComponent={RowComponent}
        sorting={this.getSorting()}
        viewName={viewName}
      />
    );
  }
}

TenantMobileGrid.propTypes = {
  onActionExecuting: PropTypes.func,
  viewName: PropTypes.string,
};

export default TenantMobileGrid;
